import styled, { css } from "styled-components";

import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { INTEGRATION_WIDTH_LARGE } from "app/pages/sales-intelligence/pages/manage-export/style";

// Wider than the shared integration width so each of the three scoring board columns fits its header in one row.
const PLAYBOOK_WIZARD_WIDTH = "1120px";

const playbookWizardMaxWidth = css`
    max-width: ${PLAYBOOK_WIZARD_WIDTH};

    @media (min-width: 1920px) {
        max-width: ${INTEGRATION_WIDTH_LARGE};
    }
`;

export const StyledPlaybookWizardTitle = styled(Stack)`
    ${playbookWizardMaxWidth};
`;

export const StyledPlaybookWizardLegend = styled(Stack)`
    & > div {
        animation: none;
    }
`;

export const StyledPlaybookWizardContent = styled(Stack)`
    ${playbookWizardMaxWidth};
`;

export const StyledPlaybookWizardFooterContent = styled(Flex)`
    ${playbookWizardMaxWidth};
`;
